
import { Component, Vue, } from 'vue-property-decorator';
import { Store, } from '~/apps/account/store';
import HeaderText from '~/components/header-text/header-text.vue';
import LandingLink from '~/components/landing-link/landing-link.vue';
import { preventLeaveMixin, } from '~/mixins/prevent-leave-mixin';

@Component({
	components: {
		HeaderText,
		LandingLink,
	},
	metaInfo: {
		title: 'Digital billing - Verification - Southern Water',
	},
	mixins: [
		preventLeaveMixin,
	],
})
export default class EmailVerification extends Vue {
	apiError: string | null = null;
	customerEmail = Store.state.register.customerDetails?.customerEmail;

	mounted() {
		Store.commit.register.setStep(4);
	}
}
